import React from 'react';

const NAV_ITEMS = [
  { id: 'dashboard', icon: '⬡',  label: 'Dashboard'  },
  { id: 'chat',      icon: '✏️',  label: 'Nuevo'      },
  { id: 'contexts',  icon: '🗂️',  label: 'Contextos'  },
  { id: 'tasks',     icon: '✅',  label: 'Tareas'     },
  { id: 'decisions', icon: '🎯',  label: 'Decisiones' },
];

function MobileNav({ currentView, onNavigate }) {
  return (
    <nav className="mobile-nav">
      {NAV_ITEMS.map(item => (
        <button
          key={item.id}
          className={`mobile-nav__item${currentView === item.id ? ' active' : ''}`}
          onClick={() => onNavigate(item.id)}
          aria-label={item.label}
        >
          <span className="mobile-nav__icon">{item.icon}</span>
          <span className="mobile-nav__label">{item.label}</span>
        </button>
      ))}
    </nav>
  );
}

export default MobileNav;
